<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        flat
        :disabled="dialog"
        v-on="on"
      >
        <v-icon left>
          cloud_upload
        </v-icon>
        Upload
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <v-layout
          justify-space-between
          align-center
        >
          <span class="headline">Upload Image</span>
          <v-btn
            flat
            color="info"
            @click="$refs.file_handler.click()"
          >
            Select a photo
          </v-btn>
          <input
            v-show="false"
            ref="file_handler"
            type="file"
            accept="image/*"
            @change="onFileChanged"
          >
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <div
              v-if="errors !== null"
              class="title text-xs-center error--text"
            >
              {{ errors }}
            </div>
            <v-img
              v-else
              :src="preview_image ? preview_image : noImage"
              :lazy-src="preview_image ? preview_image : noImage"
              aspect-ratio="1.7778"
              alt="Preview Image"
              title="Preview Image"
            />
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="grey"
          flat
          @click="onCloseDialog"
        >
          Cancel
        </v-btn>
        <v-btn
          color="success"
          flat
          :disabled="selected_file === null"
          :loading="isSubmitting"
          @click.stop="onSubmitForm"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
const noImage = require('@/assets/no_image_found.png')
export default {
  props: {
    itemObject: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    dialog: false,
    isSubmitting: false,
    noImage: noImage,
    selected_file: null,
    preview_image: null,
    errors: null
  }),
  watch: {
    errors (value) {
      if (value !== null) {
        this.selected_file = null
        this.preview_image = null
      }
    }
  },
  methods: {
    ...mapActions({
      getGalleries: 'blogGallery/getGalleries',
      uploadImage: 'blogPosts/uploadImage'
    }),
    onFileChanged (event) {
      this.selected_file = event.target.files[0]
      if (this.selected_file !== undefined) {
        this.preview_image = URL.createObjectURL(this.selected_file)
      } else if (this.selected_file === undefined) {
        this.selected_file = null
        this.preview_image = null
      }
    },
    onCloseDialog () {
      if (this.errors !== null) {
        this.errors = null
      }
      this.selected_file = null
      this.preview_image = null
      this.dialog = false
    },
    onSubmitForm () {
      this.isSubmitting = true
      const formData = new FormData()
      formData.append('image', this.selected_file)
      this.uploadImage(formData)
      .then((response) => {
        if (response === undefined) {
          this.isSubmitting = false
        } else if (response.status === 201) {
          this.getGalleries()
          .then(() => {
            this.isSubmitting = false
            this.dialog = false
            this.itemObject.image = response.data.data
          })
        }
      }).catch((error) => {
        this.isSubmitting = false
        this.errors = error.image[0]
      })
    }
  }
}
</script>
